import React from 'react';
import style from '../../PaperworkList/PaperworkList.module.css';
import s from '../ProductReport.module.css';
import {DataInDataMovementsType} from '../../../types/StoreReportTypes';
type Props = {
	product: DataInDataMovementsType;
};
const ProductTableRowEl: React.FC<Props> = ({product}) => {
	const {
		img,
		name,
		count_start,
		count_income,
		count_return,
		count_order,
		count_finish,
	} = product;

	return (
		<div
			className={`${style.tableRow}`}
			style={{gridTemplateColumns: '1fr 2fr repeat(5, 1fr)'}}
		>
			<div className={style.tableColumn}>
				<img src={img} alt={name} />
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>{name}</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{count_start}
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{count_income}
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{count_return}
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{count_order}
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{count_finish}
			</div>
		</div>
	);
};

export default ProductTableRowEl;
